import React from 'react'
import Drawer from '../../../../components/Drawer/Drawer'
import Box from '@mui/material/Box'
import SimpleForm from '../../../../components/SimpleForm'
import Input from '../../../../components/Input'
import { useCreateOpenScoreboardMutation } from '../../../../services/api'
import { useUiStore } from '../../../../stores/uiStore'
import { retrieveErrorMessage, slugify } from '../../../../utils/helpers'
import { useNavigate } from 'react-router-dom'

type ScoreboardDrawerProps = {
  isOpen: boolean,
  closeDrawer?: () => void,
}

const ScoreboardDrawer = ({
  isOpen,
  closeDrawer=() => {},
}: ScoreboardDrawerProps) => {
  const navigate = useNavigate()
  const [createOpenScoreboard, {isLoading}] = useCreateOpenScoreboardMutation()
  const {openErrorToast, openSuccessToast} = useUiStore()
  const onSubmit = async (values: {title: string, description: string}) => {
    try {
      const response = await createOpenScoreboard(values).unwrap()
      const scoreboardId = response.payload.id
      openSuccessToast({message: 'Scoreboard created successfully'}) 
      closeDrawer()
      navigate(`/scoreboards/${scoreboardId}/${slugify(response.payload.title)}`)
    } catch (error) {
      openErrorToast({message: retrieveErrorMessage(error)})
    }
  }

  return (
    <Drawer
      disableEnforceFocus
      showCloseIcon
      anchor='bottom'
      open={isOpen}
      onOpen={() => {}}
      onClose={closeDrawer}
      header='Create Scoreboard'
    >
      <ScoreboardDrawerForm loading={isLoading} onSubmit={onSubmit} />
    </Drawer>
  )
}


type IScoreboardDrawerForm = {
  loading: boolean,
  onSubmit: (values: {title: string, description: string}) => void
}

const ScoreboardDrawerForm = ({loading, onSubmit}: IScoreboardDrawerForm) => {
  const initialValues = {
    title: '',
    description: ''
  }

  const formFields = [
    {
      name: 'title',
      placeholder: 'Enter title',
      size: 'small',
      required: true,
      component: Input
    },
    {
      name: 'description',
      placeholder: 'Enter description',
      size: 'small',
      required: true,
      component: Input
    }
  ]
  return (
    <Box p={2}>
      <SimpleForm<{title: string, description: string}>
        animateForm
        initialValues={initialValues}
        formFields={formFields}
        actionButtons={
          {
            isSubmit: true,
            variant: 'contained',
            label: 'Create Scoreboard',
            type: 'submit',
            color: 'primary',
            loading: loading
          }
        }
        submitForm={onSubmit}
      />
    </Box>
  )
}

export default ScoreboardDrawer
